/* ─── Career metrics — single source of truth ───
   The same figures surface in the Preloader boot-log and the Signal counters.
   Keeping them here means the loader's numbers are REAL and can never drift from
   the ones the visitor reads seconds later in the Signal section. */

export const STATS = {
  network: 400, // developers reached · MENA
  builds: 100, // projects shipped
  years: 5, // years building
  est: 2021, // first line of code shipped (years = current − est)
} as const

/** Counter cards rendered in Signal — derived so the numbers stay in lockstep. */
export const METRICS = [
  { number: STATS.network, suffix: '+', label: 'NETWORK', sub: 'developers · MENA' },
  { number: STATS.builds, suffix: '+', label: 'BUILDS', sub: 'projects shipped' },
  { number: STATS.years, suffix: '+', label: 'UPTIME', sub: 'years building' },
] as const
